import { AppRoutes } from '@core/AppRoutes'
import { appHistory } from '@core/Utils/routing/history'
import type {
  FollowListTabNav,
  FollowMeProfile,
  FollowMeSharedBet,
} from '@core/Areas/FollowMe/types'
import { IncomingBetViewPostIdSearchParam } from '@core/Areas/FollowMe/Components/ProfileDisplay/constants'

export const navigateToProfileFollowingList = (profileId: FollowMeProfile['id']) =>
  appHistory.push(getFollowListRoute({ profileId, listType: 'following' }))

export const navigateToProfileFollowersList = (profileId: FollowMeProfile['id']) =>
  appHistory.push(getFollowListRoute({ profileId, listType: 'followers' }))

export const navigateToMyProfileWithViewBet = ({ postId }: Pick<FollowMeSharedBet, 'postId'>) =>
  appHistory.push(AppRoutes.BetLoopMyProfile + `?${IncomingBetViewPostIdSearchParam}=${postId}`)

// =============
// Local Helpers
// =============

function getFollowListRoute({
  listType,
  profileId,
}: {
  listType: FollowListTabNav
  profileId: FollowMeProfile['id']
}): FollowListRoute {
  return `${AppRoutes.BetLoopProfile}/${profileId}/follow-list?tab=${listType}`
}

// =====
// Types
// =====

type FollowListRoute =
  `${typeof AppRoutes.BetLoopProfile}/${FollowMeProfile['id']}/follow-list?tab=${FollowListTabNav}`
